export const state = {
  // product: undefined,
  // products: []
  confiserie: {},
  confiseries: [],
  pagination:''
}
